export const PAGE_TYPE_BASIS = 'basis';
export const PAGE_TYPE_FACH = 'fach';

export const DEFAULT_SECTION_LINES = [
  'Rahmendaten & Qualifikationen: Grundlegende Informationen über Ihre Ausbildung, Erfahrung und Verfügbarkeit',
  'Spezifische Fragen: Position-spezifische Fragen zu Ihren Fähigkeiten und Erfahrungen',
  'Überprüfung: Überprüfung Ihrer Antworten vor der finalen Einreichung'
];

export const INTRO_PAGE_ID = '__intro_page__';
export const DEFAULT_QUESTIONS_PAGE_ID = '__default_questions__';

export const DEFAULT_CUSTOM_PAGE_PRESETS = [
  { title: 'Basisfragen', pageType: PAGE_TYPE_BASIS },
  { title: 'Fachspezifische Fragen', pageType: PAGE_TYPE_FACH }
];

export const NAME_QUESTION_SEED = {
  id: 'system_name',
  type: 'text',
  text: 'Wie lautet dein vollständiger Name?',
  description: '',
  wordLimit: 'no-limit',
  options: []
};

export const DEFAULT_FORMAL_TEMPLATE_ID_STORAGE_KEY = 'questionnaire_default_formal_template_id_v1';
export const DEFAULT_BASIS_TEMPLATE_ID_STORAGE_KEY = 'questionnaire_default_basis_template_id_v1';
export const DEFAULT_FACH_TEMPLATE_ID_STORAGE_KEY = 'questionnaire_default_fach_template_id_v1';
